import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_VENDOR, SUMMARY_BY_VENDOR } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByVendorPage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByVendorQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By Vendor" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By Vendor</h1>
      <OrdersCategoryList
        categoryTitle="name"
        columns={SUMMARY_BY_VENDOR}
        unit="vendor(s)"
        resizeStorageKey="orders-by-vendor"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders for ${row.category}`}
            columns={DRILLDOWN_BY_VENDOR}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            vendorName={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByVendorPage;
